/**
 * Segmen pertama alamat yang dipakai aplikasi, server, atau berkas statis, jadi tidak boleh menjadi slug halaman
 * resto (kobe.sassly.ai/{slug}). Kembarannya di api/app/Modules/Site/Services/SiteSlugs.php; tes di kedua sisi
 * memastikan isinya sama dan semua route aplikasi tercakup. Berkas ini tidak boleh mengimpor apa pun.
 */
export const RESERVED_SLUGS = [
  'about', 'account', 'admin', 'admins', 'ai', 'akun', 'api', 'app', 'appearance', 'assets', 'audit', 'auth', 'billing', 'blog',
  'broadcasting', 'build', 'c', 'cash', 'companies', 'company', 'customers', 'demo', 'devices', 'display', 'docs', 'help', 'home',
  'icon-192.png', 'icon-512.png', 'index', 'integrations', 'invite', 'kds', 'knowledge', 'kobe', 'library', 'login', 'logout', 'logs', 'loyalty',
  'manifest.webmanifest', 'menu', 'new', 'notifications', 'onboarding', 'orders', 'outlet', 'payments', 'plans', 'platform', 'pricing',
  'privacy', 'promotions', 'q', 'r', 'register', 'reports', 'robots.txt', 'sanctum', 'sassly', 'settings', 'signup', 'site', 'static',
  'stock', 'storage', 'support', 'sw.js', 'tables', 'terms', 'transactions', 'tv', 'tv-screens', 'up', 'users', 'w', 'waiter', 'waitlist',
  'webhooks', 'wl', 'www', 'favicon.svg', 'favicon.ico',
] as const;

/** Bentuk slug resto: huruf kecil, angka, dan tanda hubung, 3 sampai 60 karakter. */
export const SLUG_PATTERN = /^[a-z0-9](?:[a-z0-9-]{1,58}[a-z0-9])$/;

export function isReservedSlug(slug: string): boolean {
  return (RESERVED_SLUGS as readonly string[]).includes(slug.toLowerCase());
}
